<style lang="scss" scoped>
.recommend-container {
  width: 726px;
  margin: 48px 0 0 24px;
  .title {
    font-size: 28px;
    line-height: 40px;
    color: #1d1d1d;
    margin-bottom: 22px;
    font-weight: bold;
  }
  .split-container {
    display: flex;
    .line-start {
      height: 2px;
      width: 146px;
      background-color: #1d1d1d;
      box-sizing: border-box;
      border: 1px solid #1d1d1d;
    }
    .line-end {
      width: 580px;
      height: 2px;
      background-color: #eeeeee;
      box-sizing: border-box;
      border: 1px solid #eeeeee;
    }
  }
  .r-pd-container {
    width: 726px;
    position: relative;
    height: 448px;
    overflow-x: scroll;
    margin-top: 24px;
    .pd-content {
      position: absolute;
      display: flex;
      .pd-item {
        width: 273px;
        margin-right: 16px;
        background-color: #ffffff;
        height: 448px;
        .main-container {
          position: relative;
          width: 273px;
          height: 273px;
          border: 2px solid #eee;
          box-sizing: border-box;
          overflow: hidden;
          .pd-picture {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }
          .grade {
            position: absolute;
            left: 0;
            top: 0;
            height: 28px;
            line-height: 28px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 8px;
            color: #ffffff;
            // font-style: italic;
            font-size: 18px;
            // font-weight: bold;
            background: #FFB6B6;
          }
          .apprasial-label {
            position: absolute;
            right: 0;
            top: 0;
            height: 28px;
            line-height: 28px;
            padding: 0 5px;
            color: #ffffff;
            font-style: italic;
            font-size: 18px;
            font-weight: bold;
            background: linear-gradient(#835dfd, #8f8af5);
          }
          .to-seckill {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 36px;
            line-height: 36px;
            box-sizing: border-box;
            border: 1px solid #fc4655;
            background-color: #ffffff;
            padding: 0 10px;
            color: #fc4655;
            font-size: 20px;
            font-weight: bold;
          }
          .on-seckill {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 284px;
            height: 40px;
            line-height: 40px;
            color: #ffffff;
            background: linear-gradient(270deg, #ff3155, #ff5a1f);
            font-size: 22px;
            font-weight: bold;
            text-align: center;
          }
        }
        .brand-container {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-top: 7px;
          .grade {
            display: inline-block;
            height: 28px;
            font-size: 18px;
            color: #8ab1e9;
            line-height: 28px;
            padding: 0 4px;
            box-sizing: border-box;
            border: 1px solid #8ab1e9;
            border-radius: 2px;
            margin: 10px 4px 0 0;
          }
          .brand-name {
            font-size: 24px;
            color: #1d1d1d;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .officical-icon {
            display: inline-block;
            position: relative;
            top: -4px;
            color: #ffffff;
            font-size: 18px;
            line-height: 28px;
            // @include txts(18px, #ffffff, 28px);
            min-width: 48px;
            text-align: center;
            background: #8DB7EE;
            margin-right: 8px;
            background-image: linear-gradient(-42deg, #5B86FF 0%, #A1DAFF 100%);
          }
          .product-name {
            font-size: 24px;
            line-height: 32px;
            color: #666;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .product-name {
          font-size: 24px;
          line-height: 32px;
          color: #666;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .normal-price {
          margin-top: 10px;
          .price {
            padding: 0 4px;
            color: #2d2d2d;
            font-size: 28px;
            height: 40px;
            line-height: 40px;
          }
        }
        .seckill-price {
          .price {
            padding: 0 4px;
            color: #2d2d2d;
            font-size: 28px;
            height: 40px;
            line-height: 40px;
            position:relative;
            left: -8px;
            &.seckill {
              color: #fc4655;
            }
          }
          .official-price {
            color: #999999;
            font-size: 24px;
            margin-top: 10px;
            text-decoration-line: line-through;
          }
          .note-label {
            position: relative;
            display: inline-block;
            height: 36px;
            padding: 0 6px;
            line-height: 36px;
            color: #fc4655;
            box-sizing: border-box;
            border: 1px solid #fc4655;
            font-size: 20px; 
            margin-left: 10px;
            &::before {
              content: '';
              position: absolute;
              left: -10px;
              top: 10px;
              display: block;
              width: 10px;
              height: 10px;
              box-sizing: border-box;
              border: 5px solid transparent;
              border-right: 5px solid #fc4655;
            }
            &::after {
              content: '';
              position: absolute;
              left: -8px;
              top: 11px;
              display: block;
              width: 8px;
              height: 8px;
              box-sizing: border-box;
              border: 4px solid transparent;
              border-right: 4px solid #ffffff;
            }
          }
        }
        .apprasial-label {
            height: 28px;
            line-height: 22px;
            color: #ffffff;
            font-style: italic;
            font-size: 14px;
            font-weight: bold;
            display: inline-block;
            margin-right: 4px;
            .a-icon {
              height: 28px;
              width: 92px;
            }
        }
        .seckill-label {
            height: 28px;
            line-height: 22px;
            color: #FC4655;
            font-size: 14px;
            font-weight: bold;
            display: inline-block;
            .s-icon {
              height: 28px;
              width: 48px;
            }
        }
      }
      .load-more {
        // line-height: 258px;
        text-align: center;
        height: 250px;
        width: 80px;
        font-size: 24px;
        letter-spacing: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        // writing-mode: vertical-lr;
        // position: absolute;
        // right: -100px;
      }
    }
  }
}
</style>

<template>
<div class="recommend-container">
  <div class="title">为您推荐</div>
  <div class="r-pd-container">
    <div class="pd-content">
      <div class="pd-item" v-for="(recommendItem, index) in recommendList" :key="index"  @click="goDetail(recommendItem.pid)">
          <div class="main-container">
            <img class="pd-picture" :src="recommendItem.cover">
            <div class="grade">{{recommendItem.newsName}}</div>

            <div>
              <compute-time v-if="recommendItem.seckillState==1" :secondTime="recommendItem.seckillEndLeft"></compute-time>
            </div>
          </div>
          <div class="brand-container">
            <span v-if="recommendItem.isOfficial" class="officical-icon">自营</span>

            <span class="brand-name">{{recommendItem.brandEnName}}</span>
          </div>
          <div class="product-name">
            {{recommendItem.productName}}
          </div>
          <div class="seckill-price">
            <span :class="`price ${recommendItem.seckillState==1 ? 'seckill' : ''}`">￥{{recommendItem.seckillState==1 ? recommendItem.seckillPrice/100 : recommendItem.actualPrice/100}}</span>
            <span v-if="recommendItem.releasePrice && recommendItem.releasePrice != 0" class="official-price">￥{{recommendItem.releasePrice / 100}}</span>
          </div>
          <div  v-if="recommendItem.relatedOaID"  class="apprasial-label">
            <img class="a-icon" src="./../../../assets/images/ai-picture/apprasial-icon.png">
          </div>
          <div v-if="recommendItem.seckillState==1" class="seckill-label">
            <img class="s-icon" src="./../../../assets/images/ai-picture/seckill-icon.png">
          </div>
        </div>
      </div>
  </div>
</div>
</template>

<script>
import ComputeTime from './compute-time';
// import {isTestEnv} from './../../common/constant'
import { H5PAGES_TARO_CONFIG } from './../../../common/navigate-config.js'

export default {
  components: {
    ComputeTime
  },
  props: {
    recommendList: {
      default: () => {
        return []
      }
    }
  },
  watch: {
    recommendList: function (val) {
      if (this.recommendScroll) {
        setTimeout(() => this.recommendScroll.refresh());
      }
    },
  },
  data () {
    return {
    }
  },
  methods: {
    goOnsale () {
      this.$router.push({ name: 'onSale' })
    },
    goDetail (pid) {
      if (window.isWXWebView) {
        wx.miniProgram.navigateTo({ url: `/pages/choice/detail?pid=${pid}` });
      } else {
        H5PAGES_TARO_CONFIG.toProductDetail(pid)
        // window.location.href = isTestEnv ? `https://baoh5test.turingsenseai.com/h5/#/pages/choice/detail?pid=${pid}` : `https://baoh5.turingsenseai.com/h5/#/pages/choice/detail?pid=${pid}`
      }
    }
  },
  mounted () {
  }
}
</script>
